import React, { useState } from "react";
import { Form, Input } from "antd";
import { Lock } from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import { Md3Button } from "../../shared/components";
import { useAuth } from "../../hooks/auth";
import { MobileFormCard, Subtitle, Title } from "../Register/styles";

const ChangePasswordPage: React.FC = () => {
  const [form] = Form.useForm();
  const { changePassword, loadingAuth } = useAuth();
  const [submitting, setSubmitting] = useState(false);

  const handleFinish = async (values: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    if (values.newPassword !== values.confirmPassword) {
      form.setFields([
        {
          name: "confirmPassword",
          errors: ["As senhas não coincidem"],
        },
      ]);
      return;
    }

    setSubmitting(true);
    try {
      await changePassword(values.currentPassword, values.newPassword);
      form.resetFields();
    } catch {
      /* toast via auth hook */
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MobileLayout headerTitle="Alterar senha" headerType="private">
      <MobileFormCard>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <Title>Alterar senha</Title>
          <Subtitle>Digite sua senha atual e escolha uma nova senha.</Subtitle>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          requiredMark={false}
        >
          <Form.Item
            name="currentPassword"
            label="Senha atual"
            rules={[{ required: true, message: "Informe a senha atual" }]}
          >
            <Input.Password
              size="large"
              placeholder="Senha atual"
              prefix={<Lock size={18} variant="Bold" />}
            />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="Nova senha"
            rules={[
              { required: true, message: "Informe a nova senha" },
              { min: 6, message: "Mínimo de 6 caracteres" },
            ]}
          >
            <Input.Password size="large" placeholder="Nova senha" />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirmar nova senha"
            rules={[{ required: true, message: "Confirme a nova senha" }]}
          >
            <Input.Password size="large" placeholder="Repita a nova senha" />
          </Form.Item>

          <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
            <Md3Button
              type="submit"
              title="Salvar nova senha"
              size="large"
              fullWidth
              loading={submitting || loadingAuth}
            />
          </Form.Item>
        </Form>
      </MobileFormCard>
    </MobileLayout>
  );
};

export default ChangePasswordPage;
